const isTheSameArticulo = (a: $TSMigrationFixMe, b: $TSMigrationFixMe) =>
  a.id === b.id

const getArticulosRepeated = (
  articulos: $TSMigrationFixMe,
  articulo: $TSMigrationFixMe
) =>
  articulos.filter((currentArticulo: $TSMigrationFixMe) =>
    isTheSameArticulo(articulo, currentArticulo)
  )

const mergeRepeatedArticulos = (articulos = []) => {
  const seenRepeatedArticulosId = new Set()
  let mergedArticulos: $TSMigrationFixMe = []

  articulos.forEach((articulo) => {
    // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
    if (seenRepeatedArticulosId.has(articulo.id)) return

    const repeatedArticulos = getArticulosRepeated(articulos, articulo)
    repeatedArticulos.forEach(({ id }: $TSMigrationFixMe) =>
      seenRepeatedArticulosId.add(id)
    )

    let mergedArticulo: $TSMigrationFixMe = null
    repeatedArticulos.forEach((art: $TSMigrationFixMe) => {
      if (!mergedArticulo) mergedArticulo = art
      else {
        mergedArticulo = {
          ...mergedArticulo,
          cantidad: mergedArticulo.cantidad + art.cantidad,
        }
      }
    })

    mergedArticulos = [...mergedArticulos, mergedArticulo]
  })

  return mergedArticulos
}

export default mergeRepeatedArticulos
